import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosBuzzOne } from '../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  setPasswordRoute,
  sendOtpRoute,
  verifyOtpRoute,
} from '../../utils/apiRoutes';

export const resetPwd = createAsyncThunk(
  `${moduleName}/PwdReset/resetPwd`,
  async (payload) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: setPasswordRoute(),
        data: payload,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const sendOtpMail = createAsyncThunk(
  `${moduleName}/PwdReset/sendOtpMail`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'POST',
      url: sendOtpRoute(),
      data: payload,
    });
    return response.data;
  }
);

export const verifyOtpMail = createAsyncThunk(
  `${moduleName}/PwdReset/verifyOtpMail`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'POST',
      url: verifyOtpRoute(),
      data: payload,
    });
    return response.data;
  }
);

const forgetPwdSlice = createSlice({
  name: `${moduleName}/forgetPwd`,
  initialState: {
    loading: false,
    data: null,
    resetPwd: null,
    sendOtp: null,
    error: null,
    verifyOtp: null,
  },
  reducers: {
    otpLoading: (state) => {
      state.loading = true;
    },
    setEmailAddress: (state, action) => {
      // console.log('action.payload', action.payload);
      state.data.email = action.payload;
    },
  },
  extraReducers: {
    [resetPwd.fulfilled]: (state, action) => {
      state.loading = false;
      // console.log('reset pwd slice', action.payload);
      state.resetPwd = action.payload.message;
    },
    [resetPwd.pending]: (state) => {
      state.loading = true;
    },
    [resetPwd.rejected]: (state) => {
      state.loading = false;
      state.error = 'failed';
    },
    [sendOtpMail.fulfilled]: (state, action) => {
      state.loading = false;
      // console.log('send otp mail slice', action.payload);
      state.sendOtp = action.payload;
      // state.sendOtp = 'success';
    },
    [sendOtpMail.pending]: (state) => {
      state.loading = true;
    },
    [sendOtpMail.rejected]: (state) => {
      state.loading = false;
      state.error = 'failed';
      state.sendOtp = 'otp send failed';
    },
    [verifyOtpMail.fulfilled]: (state, action) => {
      state.loading = false;
      state.verifyOtp = action.payload;
    },
    [verifyOtpMail.pending]: (state) => {
      state.loading = true;
    },
    [verifyOtpMail.rejected]: (state) => {
      state.loading = false;
      state.error = 'failed';
      state.sendOtp = 'otp send failed';
    },
  },
});

export const { otpLoading, setEmailAddress } = forgetPwdSlice.actions;

export default forgetPwdSlice.reducer;
